import { useCallback } from "react"
import { useAppDispatch } from "../app/hooks"
import { Options, showToast } from "../toastSlice"

export default function useShowToast() {
  const dispatch = useAppDispatch()

  return useCallback(
    (message: string, options?: Partial<Options>) => {
      dispatch(showToast({ message, options }))
    },
    [dispatch],
  )
}
